module.exports = __webpack_public_path__ + "img/title-1.e363010d.png";